import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/stores/user'
import Search from '@/pages/Search.vue'
import ContractImages from '@/pages/ContractImages.vue'
import ProductImages from '@/pages/ProductImages.vue'
import InventoryImages from '@/pages/InventoryImages.vue'
import AreaProduct from '@/pages/AeraProduct.vue'
import AreaProductImage from '@/pages/AreaProductImage.vue'
import ProductList from '@/pages/ProductList.vue'
import Login from '@/pages/Login.vue'
import Finance from '@/pages/finance.vue'
import Group from '@/pages/group.vue'
import Report from '@/pages/Report.vue'
import { useOrderStore } from '@/stores/order'
import Inventory from '@/pages/Inventory.vue'
import Purchase from '@/pages/Purchase.vue'
import PurchaseDetail from '@/pages/PurchaseDetail.vue'
import PurchaseDetailPrint from '@/pages/PurchaseDetailPrint.vue'
import Contract from '@/pages/Contract.vue'
import ContractSummary from '@/pages/ContractSummary.vue'
import ContractSummaryFinance from '@/pages/ContractSummaryFinance.vue'
import ContractEstimate from '@/pages/ContractEstimate.vue'
import ContractPendingEstimate from '@/pages/ContractPendingEstimate.vue'
import AddCommonMaterialList from '@/pages/contract/AddCommonMaterialList.vue'
import ContractMaterialList from '@/pages/contract/MaterialList.vue'
import ContractMaterialListFactory from '@/pages/contract/MaterialListFactory.vue'
import ContractMaterialListProduct from '@/pages/contract/MaterialListProduct.vue'
import ContractMaterialListSummary from '@/pages/contract/MaterialListSummary.vue'
import MaterialListProductSummary from '@/pages/contract/MaterialListProductSummary.vue'
import ContractMaterialPurchaseList from '@/pages/contract/MaterialPurchaseList.vue'
import ContractMaterialLibrary from '@/pages/contract/MaterialLibrary.vue'
import ContractProductLibrary from '@/pages/contract/ProductLibrary.vue'
import SupplierLibrary from '@/pages/SupplierLibrary.vue'
import BoxCode from '@/pages/BoxCode.vue'
import ContractBin from '@/pages/ContractBin.vue'
import Landing from '@/pages/Landing.vue'
import ShareProductionProgress from '@/pages/shareProductionProgress.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
    meta: {
      title: '数字江丰 - 智能制造系统',
      requiresAuth: false
    }
  },
  {
    path: '/contract',
    name: 'contractManage',
    component: Contract,
    meta: {
      title: '我的业务',
      icon: 'mdi-file-document-edit',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/contract-summary',
    name: 'contract-summary',
    component: ContractSummary,
    meta: {
      title: '项目汇总',
      icon: 'mdi-account',
      requiresAuth: true,
      permissions: ['jf_sale']
    }
  },
  {
    path: '/contract-summary-finance',
    name: 'contract-summary-finance',
    component: ContractSummaryFinance,
    meta: {
      title: '项目汇总',
      icon: 'mdi-account',
      requiresAuth: true,
      permissions: ['jf_finance']
    }
  },
  {
    path: '/contract-bin',
    name: 'contract-bin',
    component: ContractBin,
    meta: {
      title: '回收站',
      icon: 'mdi-file-document-edit',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/newContract',
    name: 'newContract',
    component: () => import('@/pages/contract/New.vue'),
    meta: {
      title: '合同信息',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/shipNew',
    name: 'shipNew',
    component: () => import('@/pages/contract/ShipNew.vue'),
    meta: {
      title: '合同信息',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/barcodeDetail',
    name: 'barcodeDetail',
    component: () => import('@/pages/contract/BarcodeDetail.vue'),
    meta: {
      title: '条码明细',
      requiresAuth: true,
      permissions: ['jf_admin', 'jf_sale', 'jf_assign', 'jf_goods']
    }
  },
  {
    // path: '/aeraProduct/:productCode/:mode/:isCanEdit/:currency',
    path: '/aeraProduct/:productCode/:mode/:isCanEdit/:currency/:building/:roomType/:floor/:areaRoomType/:roomNumber/:quantity',
    name: 'aeraProduct',
    component: () => import('@/pages/AeraProduct.vue'),
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/areaProductImage/:contractId/:index',
    name: 'areaProductImage',
    component: AreaProductImage,
    meta: { 
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle' 
    }
  },
  {
    path: '/estimateNew',
    name: 'estimateNew',
    component: () => import('@/pages/contract/EstimateNew.vue'),
    meta: {
      title: '合同信息',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/financeNew',
    name: 'financeNew',
    component: () => import('@/pages/contract/FinanceNew.vue'),
    meta: {
      title: '合同信息',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/pending-estimate',
    name: 'contract-pending-estimate',
    component: ContractPendingEstimate,
    meta: {
      title: '估价汇总',
      icon: 'mdi-calculator',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/estimate-report',
    name: 'estimate-report',
    component: () => import('@/pages/EstimateReport.vue'),
    meta: {
      title: '估价报表',
      icon: 'mdi-calculator',
    }
  },
  {
    path: '/estimate',
    name: 'contract-estimate',
    component: ContractEstimate,
    meta: {
      title: '我的估价',
      icon: 'mdi-calculator',
      requiresAuth: true,
      permissions: ['jf_admin']
    }
  },
  {
    path: '/contract/materiallist',
    name: 'contract-materiallist',
    component: ContractMaterialList,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      // title: '物料清单',
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/addCommonMaterialList',
    name: 'contract-addCommonMaterialList',
    component: AddCommonMaterialList,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/materiallistFactory',
    name: 'contract-materiallistFactory',
    component: ContractMaterialListFactory,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      // title: '物料清单',
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/materiallistProduct',
    name: 'contract-materiallistProduct',
    component: ContractMaterialListProduct,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      // title: '物料清单',
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/materiallistsummary',
    name: 'contract-materiallistsummary',
    component: ContractMaterialListSummary,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      // title: '物料清单',
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/project/materialListProductSummary',
    name: 'project-materialListProductSummary',
    component: MaterialListProductSummary,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/materialPurchaseList',
    name: 'contract-material-purchase-list',
    component: ContractMaterialPurchaseList,
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/materiallibrary',
    name: 'contract-materiallibrary',
    component: ContractMaterialLibrary,
    meta: {
      title: '物料库',
      icon: 'mdi-database',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/contract/productlibrary',
    name: 'contract-productlibrary',
    component: ContractProductLibrary,
    meta: {
      title: '成品库',
      icon: 'mdi-database',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/supplier-library',
    name: 'supplier-library',
    component: SupplierLibrary,
    meta: {
      title: '供应商库',
      icon: 'mdi-database',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/purchase-summary',
    name: 'purchase-summary',
    component: () => import('@/pages/PurchaseSummary.vue'),
    meta: {
      title: '项目物料',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/purchase-product-summary',
    name: 'purchase-product-summary',
    component: () => import('@/pages/PurchaseProductSummary.vue'),
    meta: {
      title: '产品物料',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: { 
      title: '图纸查询',
      icon: 'mdi-file-document-outline',
      requiresAuth: true 
    }
  },
  {
    path: '/finance',
    name: 'finance',
    component: Finance,
    meta: { 
      title: '合同审核',
      icon: 'mdi-currency-usd',
      requiresAuth: true,
      permission: 'jf_finance'
    }
  },
  {
    path: '/feeAudit',
    name: 'feeAudit',
    component: () => import('@/pages/feeAudit.vue'),
    meta: { 
      title: '费用报销',
      icon: 'mdi-currency-usd',
      requiresAuth: true,
      permission: 'jf_finance'
    }
  },
  {
    path: '/reimburse',
    name: 'reimburse',
    component: () => import('@/pages/Reimburse.vue'),
    meta: { 
      title: '报销对账',
      icon: 'mdi-currency-usd',
      requiresAuth: true,
      permission: 'jf_finance'
    }
  },
  {
    path: '/purchase-payment',
    name: 'purchase-payment',
    component: () => import('@/pages/PurchasePayment.vue'),
    meta: { 
      title: '采购单',
      icon: 'mdi-cart',
      requiresAuth: true,
    }
  },
  {
    path: '/payment-reconciliation/:isMine',
    name: 'payment-reconciliation',
    component: () => import('@/pages/PaymentReconciliation.vue'),
    meta: { 
      title: '采购对账',
      icon: 'mdi-currency-usd',
      requiresAuth: true,
    }
  },
  {
    path: '/contract-reconciliation',
    name: 'contract-reconciliation',
    component: () => import('@/pages/ContractReconciliation.vue'),
    meta: { 
      title: '合同对账',
      icon: 'mdi-currency-usd',
      requiresAuth: true,
    }
  },
  {
    path: '/account-voucher',
    name: 'account-voucher',
    component: () => import('@/pages/AccountVoucher.vue'),
    meta: { 
      title: '记账凭证',
      icon: 'mdi-currency-usd',
      requiresAuth: true,
    }
  },
  
  {
    path: '/group',
    name: 'group',
    component: Group,
    meta: { 
      title: '集团审核',
      icon: 'mdi-domain',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  // {
  //   path: '/factory',
  //   name: 'factory',
  //   component: () => import('@/pages/factory.vue'),
  //   meta: {
  //     title: '工厂分配',
  //     icon: 'mdi-factory',
  //     requiresAuth: true,
  //     permission: 'jf_assign'
  //   }
  // },
  {
    path: '/contractFactory',
    name: 'contractFactory',
    component: () => import('@/pages/ContractFactory.vue'),
    meta: {
      title: '工厂分配',
      icon: 'mdi-factory',
      requiresAuth: true,
      permission: 'jf_assign'
    }
  },
  {
    path: '/factoryManufactureProgress',
    name: 'factoryManufactureProgress',
    component: () => import('@/pages/factoryManufactureProgress.vue'),
    meta: {
      title: '生产进度',
      icon: 'mdi-progress-wrench',
      // requiresAuth: true,
      // permission: 'jf_assign'
    }
  },
  {
    path: '/shareProductionProgress',
    name: 'shareProductionProgress',
    component: ShareProductionProgress,
    meta: {
      title: '二级',
      requiresAuth: false
    }
  },
  {
    path: '/factoryReport',
    name: 'factoryReport',
    component: () => import('@/pages/factoryReport.vue'),
    meta: {
      title: '报工查询',
      icon: 'mdi-progress-wrench',
      // requiresAuth: true,
      // permission: 'jf_assign'
    }
  },
  {
    path: '/factoryReportManage',
    name: 'factoryReportManage',
    component: () => import('@/pages/factoryReportManage.vue'),
    meta: {
      title: '报工查询',
      icon: 'mdi-progress-wrench',
      // requiresAuth: true,
      // permission: 'jf_assign'
    }
  },
  {
    path: '/output-report',
    name: 'output-report',
    component: () => import('@/pages/OutputReport.vue'),
    meta: {
      title: '产值报表',
      icon: 'mdi-chart-bar',
      // requiresAuth: true,
      // permission: 'jf_group'
    }
  },
  {
    path: '/factoryManufacture',
    name: 'factoryManufacture',
    component: () => import('@/pages/factoryManufacture.vue'),
    meta: {
      title: '生产列表',
      icon: 'mdi-factory'
    }
  },
  {
    path: '/purchase-manufacture',
    name: 'purchase-manufacture',
    component: () => import('@/pages/PurchaseManufacture.vue'),
    meta: {
      title: '采购单',
      icon: 'mdi-cart'
    }
  },
  {
    path: '/factoryManufactureProduct/:contractId',
    name: 'factoryManufactureProduct',
    component: () => import('@/pages/factoryManufactureProduct.vue'),
    meta: {
      title: '二级',
      icon: 'mdi-factory'
    }
  },
  {
    path: '/production-order-list',
    name: 'productionOrderList',
    component: () => import('@/pages/ProductionOrderList.vue'),
    meta: {
      title: '转生产',
      icon: 'mdi-clipboard-list'
    }
  },
  {
    path: '/contractPendingFactory/:contractId',
    name: 'contractPendingFactory',
    component: () => import('@/pages/ContractPendingFactory.vue'),
    meta: {
      title: '二级',
      icon: 'mdi-factory',
      requiresAuth: true,
      permission: 'jf_assign'
    }
  },
  {
    path: '/staff',
    name: 'staff',
    component: () => import('@/pages/staff.vue'),
    meta: {
      title: '人员管理',
      icon: 'mdi-account-group',
      requiresAuth: true,
      permission: 'jf_admin'
    }
  },
  {
    path: '/contract/:contractId/contract-draws',
    name: 'ContractImages',
    component: ContractImages,
    meta: { 
      // title: '合同图纸',
      title: '二级',
      icon: 'mdi-file-image',
      requiresAuth: true 
    }
  },
  {
    path: '/contract/:contractId/product/:productId/images',
    name: 'ProductImages',
    component: ProductImages,
    meta: { 
      // title: '产品图纸',
      title: '二级',
      icon: 'mdi-image-album',
      requiresAuth: true 
    }
  },
  {
    path: '/contract/:contractId/inventory',
    name: 'InventoryImages',
    component: InventoryImages,
    meta: { 
      // title: '其他图纸',
      title: '二级',
      icon: 'mdi-package-variant-closed',
      requiresAuth: true 
    }
  },
  {
    path: '/contract/:contractId/products',
    name: 'ProductList',
    component: ProductList,
    meta: { 
      // title: '产品列表',
      title: '二级',
      icon: 'mdi-format-list-bulleted',
      requiresAuth: true 
    }
  },
  {
    path: '/maintain',
    name: 'maintain',
    component: () => import('@/pages/Maintain.vue'),
    meta: { 
      title: '江丰智造',
      requiresAuth: false 
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { 
      title: '登录',
      requiresAuth: false 
    }
  },
  {
    path: '/inventory',
    name: 'inventory',
    component: Inventory,
    meta: { 
      title: '库存管理',
      icon: 'mdi-package-variant',
      requiresAuth: true,
      // permission: 'jf_goods'
    }
  },
  {
    path: '/shipment-list',
    name: 'shipment-list',
    component: () => import('@/pages/ShipmentList.vue'),
    meta: {
      title: '项目汇总',
      icon: 'mdi-shipment',
      requiresAuth: true,
    }
  },
  {
    path: '/customer-shipment-list',
    name: 'customer-shipment-list',
    component: () => import('@/pages/ShipmentList.vue'),
    meta: {
      title: '项目汇总',
      requiresAuth: true,
    }
  },
  {
    path: '/shipment-summary-list',
    name: 'shipment-summary-list',
    component: () => import('@/pages/ShipmentSummaryList.vue'),
    meta: {
      title: '备货单汇总',
      icon: 'mdi-truck-delivery-outline',
      requiresAuth: true,
    }
  },
  {
    path: '/delivery-order-list',
    name: 'delivery-order-list',
    component: () => import('@/pages/DeliveryOrderList.vue'),
    meta: {
      title: '发货单汇总',
      icon: 'mdi-truck-delivery-outline',
      requiresAuth: true,
    }
  },
  {
    path: '/box-code',
    name: 'box-code',
    component: BoxCode,
    meta: {
      title: '箱子码',
      icon: 'mdi-package-variant-closed',
      requiresAuth: true,
      permissions: ['jf_shipment']
    }
  },
  {
    path: '/truck-summary',
    name: 'truck-summary',
    component: () => import('@/pages/TruckSummary.vue'),
    meta: {
      title: '车辆汇总',
      icon: 'mdi-truck',
      requiresAuth: true,
      permissions: ['jf_shipment']
    }
  },
  {
    path: '/truck-summary-detail',
    name: 'truck-summary-detail',
    component: () => import('@/pages/TruckSummaryDetail.vue'),
    meta: {
      title: '车辆汇总详情',
      requiresAuth: true,
    }
  },
  {
      path: '/purchase-my',
      name: 'purchase-my',
      component: () => import('@/pages/PurchaseMy.vue'),
      meta: { 
        title: '我的采购单',
        icon: 'mdi-cart',
        requiresAuth: true,
      }
  },
  {
    path: '/purchase-list',
    name: 'purchase-list',
    component: () => import('@/pages/PurchaseList.vue'),
    meta: {
      title: '采购单',
      icon: 'mdi-cart',
      requiresAuth: true,
    }
  },
  {
    path: '/purchase-my-car',
    name: 'purchase-my-car',
    component: () => import('@/pages/PurchaseMyCar.vue'),
    meta: { 
      title: '我的采购项',
      icon: 'mdi-cart',
      requiresAuth: true,
    }
  },
  {
    path: '/purchase-all',
    name: 'purchase-all',
    component: () => import('@/pages/PurchaseAll.vue'),
    meta: {
      title: '采购汇总',
      icon: 'mdi-account',
      requiresAuth: true,
    }
  },
  {
    path: '/purchase-requisition',
    name: 'purchase-requisition',
    component: () => import('@/pages/PurchaseRequisition.vue'),
    meta: {
      title: '请购汇总',
      icon: 'mdi-account',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/purchase',
    name: 'purchase',
    component: Purchase,
    meta: { 
      title: '签字',
      icon: 'mdi-cart',
      requiresAuth: true,
      permission: 'jf_p_p_s'
    }
  },
  {
    path: '/purchase-requisition-my',
    name: 'purchase-requisition-my',
    component: () => import('@/pages/PurchaseRequisitionMy.vue'),
    meta: {
      title: '我的请购单',
      icon: 'mdi-account',
      requiresAuth: true,
      // permissions: ['jf_goods']
    }
  },
  {
    path: '/material-library',
    name: 'material-library',
    component: ContractMaterialLibrary,
    meta: {
      title: '物料库',
      icon: 'mdi-file-document',
      requiresAuth: true,
    }
  },
  {
    path: '/product-library',
    name: 'product-library',
    component: ContractProductLibrary,
    meta: {
      title: '成品库',
      icon: 'mdi-database',
      requiresAuth: true,
    }
  },
  {
    path: '/supplier-library',
    name: 'supplier-library',
    component: SupplierLibrary,
    meta: {
      title: '供应商库',
      icon: 'mdi-database',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/purchase-summary',
    name: 'purchase-summary',
    component: () => import('@/pages/PurchaseSummary.vue'),
    meta: {
      title: '项目物料',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/purchase-product-summary',
    name: 'purchase-product-summary',
    component: () => import('@/pages/PurchaseProductSummary.vue'),
    meta: {
      title: '产品物料',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permissions: ['jf_goods']
    }
  },
  {
    path: '/purchase/detail/:id/:type/:authkind?',
    name: 'purchaseDetail',
    component: PurchaseDetail,
    meta: { 
      // title: '采购单详情',
      title: '二级',
      icon: 'mdi-cart-outline',
      requiresAuth: true,
      // permission: 'jf_goods'
    }
  },
  {
    path: '/purchaseprint/detail/:id/:type/:authkind?',
    name: 'purchaseDetailPrint',
    component: PurchaseDetailPrint,
    meta: { 
      // title: '采购单详情',
      title: '二级',
      icon: 'mdi-cart-outline',
      requiresAuth: true,
      // permission: 'jf_goods'
    }
  },
  {
    path: '/material-control',
    name: 'material-control',
    component: () => import('@/pages/MaterialControl.vue'),
    meta: {
      title: '我的物控',
      parentTitle: '物控',
      icon: 'mdi-format-list-checks',
      requiresAuth: true,
      // permission: 'jf_admin'
    }
  },
  {
    path: '/material-pending-control',
    name: 'material-pending-control',
    component: () => import('@/pages/MaterialPendingControl.vue'),
    meta: {
      title: '物控汇总',
      parentTitle: '物控',
      icon: 'mdi-format-list-checks',
      requiresAuth: true,
      // permission: 'jf_admin'
    }
  },
  {
    path: '/material-pending-control-manage',
    name: 'material-pending-control-manage',
    component: () => import('@/pages/MaterialPendingControlManage.vue'),
    meta: {
      title: '产品复核',
      parentTitle: '物控',
      icon: 'mdi-format-list-checks',
      requiresAuth: true,
      // permission: 'jf_admin'
    }
  },
  {
    path: '/material-contract-pending-control/:productOrderItemId',
    name: 'material-contract-pending-control',
    component: () => import('@/pages/MaterialContractPendingControl.vue'),
    meta: {
      title: '二级',
      parentTitle: '物控',
      icon: 'mdi-format-list-checks',
      requiresAuth: true,
      // permission: 'jf_admin'
    }
  },
  {
    path: '/material-contract-wukongpending-control/:contractId',
    name: 'material-contract-wukongpending-control',
    component: () => import('@/pages/MaterialContractWukongPendingControl.vue'),
    meta: {
      title: '二级',
      parentTitle: '物控',
      icon: 'mdi-format-list-checks',
      requiresAuth: true,
      // permission: 'jf_admin'
    }
  },
  {
    path: '/material-product-estimate/:contractId/:productOrderItemId/:originId',
    name: 'material-product-estimate',
    component: () => import('@/pages/MaterialProductEstimate.vue'),
    meta: {
      title: '二级',
      parentTitle: '物控',
      icon: 'mdi-format-list-checks',
      requiresAuth: true,
      // permission: 'jf_admin'
    }
  },
  {
    path: '/group-audit',
    name: 'group-audit',
    component: () => import('@/pages/AuditGroup.vue'),
    meta: {
      title: '集团审核',
      parentTitle: '集团',
      icon: 'mdi-check-circle',
      requiresAuth: true,
      // permission: 'jf_group'
    } 
  },
  {
    path: '/report',
    name: 'report',
    component: Report,
    meta: {
      title: '集团报表',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/contract-group',
    name: 'contract-group',
    component: () => import('@/pages/ContractGroup.vue'),
    meta: {
      title: '合同总览',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/company-hour',
    name: 'company-hour',
    component: () => import('@/pages/CompanyHour.vue'),
    meta: {
      title: '工时总览',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/product-hour',
    name: 'product-hour',
    component: () => import('@/pages/ProductHour.vue'),
    meta: {
      title: '工时统计',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/project-track',
    name: 'project-track',
    component: () => import('@/pages/ProjectTrack.vue'),
    meta: {
      title: '项目追踪',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/project-track-detail/:id',
    name: 'project-track-detail',
    component: () => import('@/pages/ProjectTrackDetail.vue'),
    meta: {
      title: '项目追踪-二级',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/contract-design',
    name: 'contract-design',
    component: () => import('@/pages/ContractDesign.vue'),
    meta: {
      title: '设计总览',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/contract-user',
    name: 'contract-user',
    component: () => import('@/pages/ContractUser.vue'),
    meta: {
      title: '人员总览',
      parentTitle: '集团',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_group'
    }
  },
  {
    path: '/finance-audit',
    name: 'finance-audit',
    component: () => import('@/pages/AuditFinance.vue'),
    meta: {         
      title: '审核',
      parentTitle: '财务',
      icon: 'mdi-check-circle',
      requiresAuth: true,
      // permission: 'jf_finance'
    }
  },
  {
    path: '/contract/MaterialControlList',
    name: 'contract-materialcontrollist',
    component: () => import('@/pages/contract/MaterialControlList.vue'),
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '物控记录',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/MaterialSummaryDetail',
    name: 'contract-material-summary-detail',
    component: () => import('@/pages/contract/SummaryDetail.vue'),
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/BomMaterialSummaryDetail',
    name: 'contract-bom-material-summary-detail',
    component: () => import('@/pages/contract/BomSummaryDetail.vue'),
    meta: {
      requiresAuth: true,
      permissions: ['jf_admin'],
      title: '二级',
      icon: 'mdi-plus-circle'
    }
  },
  {
    path: '/contract/shipment-detail/:stockOrderId/:isEdit?',
    name: 'contract-shipment-detail',
    component: () => import('@/pages/contract/ShipmentDetail.vue'),
    meta: {
      requiresAuth: true,
      title: '二级',
      icon: 'mdi-truck-delivery'
    }
  },
  {
    path: '/contract/delivery-detail/:deliveryId/:isEdit?',
    name: 'contract-delivery-detail',
    component: () => import('@/pages/contract/DeliveryOrderDetail.vue'),
    meta: {
      requiresAuth: true,
      title: '二级',
      icon: 'mdi-truck-delivery'
    }
  },
  {
    path: '/design-control',
    name: 'design-control',
    component: () => import('@/pages/Design.vue'),
    meta: {
      title: '我的设计',
      parentTitle: '设计',
      icon: 'mdi-file-document',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/design-pending-control',
    name: 'design-pending-control',
    component: () => import('@/pages/DesignPending.vue'),
    meta: {
      title: '设计汇总',
      parentTitle: '设计',
      icon: 'mdi-file-document',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/design-report',
    name: 'design-report',
    component: () => import('@/pages/DesignReport.vue'),
    meta: {
      title: '设计报表',
      parentTitle: '设计',
      icon: 'mdi-chart-line',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/design-report/designer-products/:designerId',
    name: 'design-report-designer-products',
    component: () => import('@/pages/DesignReportDesignerProducts.vue'),
    meta: {
      hideAppBar: true
    }
  },
   {
    path: '/design-update',
    name: 'design-update',
    component: () => import('@/pages/DesignUpdate.vue'),
    meta: {
      title: '图纸变更',
      parentTitle: '设计',
      icon: 'mdi-chart-line',
      requiresAuth: true,
      permission: 'jf_design'
    }
  },
  {
    path: '/design-contract-pending/:contractId',
    name: 'design-contract-pending',
    component: () => import('@/pages/DesignContractPending.vue'),
    meta: {
      title: '二级',
      parentTitle: '设计',
      icon: 'mdi-file-document',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/estimate-contract-pending/:contractId',
    name: 'estimate-contract-pending',
    component: () => import('@/pages/EstimateContractPending.vue'),
    meta: {
      title: '二级',
      parentTitle: '估价',
      icon: 'mdi-file-document',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/estimate-contract-wukongpending/:contractId',
    name: 'estimate-contract-wukongpending',
    component: () => import('@/pages/EstimateContractWukongPending.vue'),
    meta: {
      title: '二级',
      parentTitle: '估价',
      icon: 'mdi-file-document',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/estimate-contract-pending-control/:contractId',
    name: 'estimate-contract-pending-control',
    component: () => import('@/pages/EstimateContractPendingControl.vue'),
    meta: {
      title: '二级',
      parentTitle: '估价',
      icon: 'mdi-file-document',
      // requiresAuth: true,
      // permission: 'jf_design'
    }
  },
  {
    path: '/design-control/:contractId/product/:productId/design/:mode',
    name: 'DesignImages',
    component: () => import('@/pages/DesignImages.vue'),
    meta: { 
      // title: '设计图纸',
      title: '二级',
      parentTitle: '设计',
      icon: 'mdi-file-document',
      requiresAuth: true 
    }
  },
  {
    path: '/design-draft/:contractId/product/:productId/design/:mode',
    name: 'DesignDraft',
    component: () => import('@/pages/DesignDraft.vue'),
    meta: { 
      title: '二级',
      // title: '设计图纸',
      parentTitle: '设计',
      icon: 'mdi-file-document',
      requiresAuth: true 
    }
  },
  {
    path: '/log-record/:projectId',
    name: 'log-record',
    component: () => import('@/pages/logRecord.vue'),
    meta: {
      title: '二级',
    }
  },
  {
    path: '/export-record',
    name: 'export-record',
    component: () => import('@/pages/ExportRecord.vue'),
    meta: {
      title: '二级',
    }
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/pages/Notice.vue'),
    meta: {
      title: '公告',
      requiresAuth: true,
      permissions: ['jf_anno']
    }
  },
  {
    path: '/create-notice',
    name: 'create-notice',
    component: () => import('@/pages/CreateNotice.vue'),
    meta: {
      title: '发布公告',
      requiresAuth: true,
      permissions: ['jf_anno']
    }
  },
  {
    path: '/alert-list',
    name: 'alert-list',
    component: () => import('@/pages/AlertList.vue'),
    meta: {
      title: '警讯',
      icon: 'mdi-alert-circle',
      requiresAuth: true
    }
  }
  // {
  //   path: '/work-hours',
  //   name: 'work-hours',
  //   component: () => import('@/pages/WorkHours.vue'),
  //   meta: {
  //     title: '工时管理',
  //     requiresAuth: true,
  //   }
  // }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  const requiresAuth = to.meta.requiresAuth
  const permission = to.meta.permission as 'jf_finance' | 'jf_group' | 'jf_assign' | 'jf_admin' | 'jf_goods' | 'jf_material' | 'jf_factory_1' | 'jf_factory_2' | 'jf_factory_3' | 'jf_factory_4' | 'jf_anno' | 'jf_shipment' | null

  // 更新浏览器标签页标题
  if (to.meta.title) {
    document.title = `${to.meta.title}`
  } else {
    document.title = '江丰智造'
  }

  // landing 页对所有人开放，不做重定向

  // 未登录且需要认证，重定向到登录页
  if (requiresAuth && !localStorage.getItem('token')) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
    return
  }

  // 已登录但访问登录页，重定向到首页
  if (to.name === 'login' && localStorage.getItem('token')) {
    const navMenus = getNavMenus()
    let firstAvailablePath = ''
    if (navMenus.length > 0) {
      const firstMenu = navMenus[0]
      if (firstMenu && firstMenu.children && firstMenu.children.length > 0) {
        firstAvailablePath = firstMenu.children[0].path || ''
      } else if (firstMenu && firstMenu.path) {
        firstAvailablePath = firstMenu.path
      }
    }
    next({ path: firstAvailablePath || '/search' })
    return
  }

  // 权限检查
  if (permission) {
    if (!userStore.hasPermission(permission)) {
      // 权限检查
      const navMenus = getNavMenus()
      let firstAvailablePath = '' // 默认路径
      if (navMenus.length > 0) {
        const firstMenu = navMenus[0]
        console.log(firstMenu)
        if (firstMenu && firstMenu.children && firstMenu.children.length > 0) {
          firstAvailablePath = firstMenu.children[0].path || ''
        } else if (firstMenu && firstMenu.path) {
          firstAvailablePath = firstMenu.path
        }
      }
      console.log(firstAvailablePath)
      next({ path: firstAvailablePath })
      // next({ path: '/search' })
      return
    }
  }

  // 如果离开订单相关页面，清除订单数据
  if (from.name && ['ContractImages', 'InventoryImages', 'ProductList', 'ProductImages'].includes(from.name as string) &&
      to.name && !['ContractImages', 'InventoryImages', 'ProductList', 'ProductImages'].includes(to.name as string)) {
    const orderStore = useOrderStore()
    orderStore.clearOrderData()
  }
  
  next()
})

interface MenuItem {
  title: string
  childTitle: string
  childClass: string
  icon: string
  to?: string
  permissions?: string[]
}

interface MenuConfig {
  title: string
  icon: string
  permission?: string | null
  permissions?: string[]
  children?: MenuItem[]
}

// 菜单配置
export const menuConfig: Record<string, MenuConfig> = {
  panelManage: {
    title: '警讯',
    icon: 'mdi-headset',
    children: [
      {
        title: '警讯',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/alert-list'
      }
    ]
  },
  businessControl: {
    title: '业务',
    icon: 'mdi-account-group',
    permissions: ['jf_sale'],
    children: [
      {
        title: '我的',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/contract',
        permissions: ['jf_sale']
      },
      {
        title: '转生产',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/production-order-list',
        permissions: ['jf_sale']
      },
      {
        title: '项目汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/contract-summary',
        permissions: ['jf_sale']
      },
      {
        title: '回收站',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/contract-bin',
        permissions: ['jf_sale']
      }
    ]
  },
  estimateControl: {
    title: '估价',
    icon: 'mdi-account-group',
    permissions: ['jf_cost'],
    children: [
      {
        title: '我领取的',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/estimate',
        permissions: ['jf_cost']
      },
      {
        title: '汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/pending-estimate',
        permissions: ['jf_cost']
      },
      {
        title: '估价报表',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/estimate-report',
        permissions: ['jf_cost']
      }
    ]
  },
  materialControl: {
    title: '物控',
    icon: 'mdi-package-variant-closed-check',
    permissions: ['jf_wuliao'],
    children: [
      {
        title: '我领取的',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/material-control',
        permissions: ['jf_wuliao']
      },
      {
        title: '材料复核',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/material-pending-control',
        permissions: ['jf_wuliao']
      },
      {
        title: '产品复核',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/material-pending-control-manage',
        permissions: ['jf_wuliao']
      }
    ]
  },
  designControl: {
    title: '设计',
    icon: 'mdi-package-variant-closed-check',
    permissions: ['jf_design'],
    children: [
      {
        title: '我领取的',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/design-control',
        permissions: ['jf_design']
      },
      {
        title: '汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/design-pending-control',
        permissions: ['jf_design']
      },
      {
        title: '图纸变更',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/design-update',
        permissions: ['jf_design']
      },
      {
        title: '设计报表',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/design-report',
        permissions: ['jf_design']
      },
      {
        title: '图纸查询',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/search',
        permissions: ['jf_design']
      }
    ]
  },
  boughtManage: {
    title: '采购',
    icon: 'mdi-file-document',
    permissions: ['jf_goods'],
    children: [
      // {
      //   title: '我的采购单',
      //   icon: '@/assets/purchaseCase.png',
      //   // icon: 'mdi-cart',
      //   to: '/purchase-my',
      //   permissions: ['jf_goods']
      // },
      {
        title: '采购单',
        childTitle: '我的',
        childClass: 'redStatus',
        // icon: '@/assets/purchaseCase.png'mdi-file,
        icon: '',
        to: '/purchase-list',
        permissions: ['jf_goods']
      },
      // {
      //   title: '采购汇总',
      //   icon: '',
      //   to: '/purchase-all',
      //   permissions: ['jf_goods']
      // },
      {
        title: '采购项',
        childTitle: '我的',
        childClass: 'redStatus',
        // icon: '@/assets/purchaseCar.png'mdi-cart,
        icon: '',
        to: '/purchase-my-car',
        permissions: ['jf_goods']
      },
      {
        title: '请款',
        childTitle: '请款',
        childClass: 'blueStatus',
        icon: '',
        to: '/payment-reconciliation/1',
        permissions: ['jf_goods']
      },
      {
        title: '签字',
        childTitle: '请款',
        childClass: 'blueStatus',
        icon: '',
        to: '/purchase',
        permissions: ['jf_p_p_s']
      },
      {
        title: '项目物料',
        childTitle: '资料',
        childClass: 'greenStatus',
        icon: '',
        to: '/purchase-summary',
        permissions: ['jf_goods']
      },
      {
        title: '产品物料',
        childTitle: '资料',
        childClass: 'greenStatus',
        icon: '',
        to: '/purchase-product-summary',
        permissions: ['jf_goods']
      },
      // {
      //   title: '物料库',
      //   icon: '',
      //   to: '/material-library',
      //   permissions: ['jf_goods']
      // },
      {
        title: '供应商库',
        childTitle: '资料',
        childClass: 'greenStatus',
        icon: '',
        to: '/supplier-library',
        permissions: ['jf_goods']
      },
      // {
      //   title: '库存管理',
      //   icon: '',
      //   to: '/inventory',
      //   permissions: ['jf_assign']
      // }
    ]
  },
  productionManage: {
    title: '生管',
    icon: 'mdi-file-document',
    permissions: ['jf_assign'],
    children: [
      // {
      //   title: '工厂分配',
      //   icon: '',
      //   to: '/factory',
      //   permissions: ['jf_assign']
      // },
      {
        title: '工厂分配',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/contractFactory',
        permissions: ['jf_assign']
      },
      {
        title: '生产进度',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryManufactureProgress',
        // permissions: ['jf_assign']
      },
      {
        title: '报工查询',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryReportManage',
        // permissions: ['jf_assign']
      },
    ]
  },
  factoryManufactureManage: {
    title: '工厂',
    icon: 'mdi-file-document',
    permissions: ['jf_factory_1', 'jf_factory_2', 'jf_factory_3', 'jf_factory_4'],
    children: [
      {
        title: '生产列表',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryManufacture',
        permissions: ['jf_factory_1', 'jf_factory_2', 'jf_factory_3', 'jf_factory_4']
      },
      {
        title: '采购单',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/purchase-manufacture',
        permissions: ['jf_factory_1', 'jf_factory_2', 'jf_factory_3', 'jf_factory_4']
      },
      {
        title: '生产进度',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryManufactureProgress?factory=1',
        // permissions: ['jf_assign']
      },
      {
        title: '报工查询',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryReport',
        // permissions: ['jf_assign']
      },
    ]
  },
  auditFinanceControl: {
    title: '财务',
    icon: 'mdi-check-circle',
    permissions: ['jf_finance'],
    children: [
      {
        title: '项目汇总',
        childTitle: '合同',
        childClass: 'redStatus',
        icon: '',
        to: '/contract-summary-finance',
        permissions: ['jf_finance']
      },
      {
        title: '审核',
        childTitle: '合同',
        childClass: 'redStatus',
        icon: '',
        to: '/finance-audit',
        permissions: ['jf_finance']
      },
      {
        title: '合同对账',
        childTitle: '合同',
        childClass: 'redStatus',
        icon: '',
        to: '/contract-reconciliation',
        permissions: ['jf_finance']
      },
      // {
      //   title: '费用报销',
      //   icon: '',
      //   to: '/feeAudit',
      //   permissions: ['jf_finance']
      // },
      {
        title: '采购汇总',
        childTitle: '采购',
        childClass: 'yellowStatus',
        icon: '',
        to: '/purchase-payment',
        permissions: ['jf_finance']
      },
      {
        title: '采购对账',
        childTitle: '采购',
        childClass: 'yellowStatus',
        icon: '',
        to: '/payment-reconciliation/0',
        permissions: ['jf_finance']
      },
      {
        title: '报销对账',
        childTitle: '报销',
        childClass: 'blueStatus',
        icon: '',
        to: '/reimburse',
        permissions: ['jf_finance']
      },
      {
        title: '凭证汇总',
        childTitle: '凭证',
        childClass: 'greenStatus',
        icon: '',
        to: '/account-voucher',
        permissions: ['jf_finance']
      },
    ]
  },
  auditGroupControl: {
    title: '集团',
    icon: 'mdi-check-circle',
    permissions: ['jf_group'],
    children: [
      // {
      //   title: '集团审核',
      //   icon: '',
      //   to: '/group-audit',
      //   permissions: ['jf_group']
      // },
      // {
      //   title: '集团报表',
      //   icon: '',
      //   to: '/report',
      //   permissions: ['jf_group']
      // },
      {
        title: '合同总览',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/contract-group',
        permissions: ['jf_group']
      },
      {
        title: '设计总览',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/design-report',
        permissions: ['jf_group']
      },
      // {
      //   title: '设计总览',
      //   icon: '',
      //   to: '/contract-design',
      //   permissions: ['jf_group']
      // },
      // {
      //   title: '人员总览',
      //   icon: '',
      //   to: '/contract-user',
      //   permissions: ['jf_group']
      // },
      {
        title: '工时总览',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/company-hour',
        permissions: ['jf_group']
      },
      {
        title: '报工查询',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryReportManage',
        // permissions: ['jf_assign']
      },
      // {
      //   title: '工时统计',
      //   icon: '',
      //   to: '/product-hour',
      //   permissions: ['jf_group']
      // },
      {
        title: '项目追踪',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/project-track',
        permissions: ['jf_group']
      },
      {
        title: '生产进度',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/factoryManufactureProgress',
        // permissions: ['jf_assign']
      },
      {
        title: '产值报表',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/output-report',
        permissions: ['jf_group']
      }
    ]
  },
  storeManage: {
    title: '库',
    icon: 'mdi-database',
    children: [
      {
        title: '我的请购',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/purchase-requisition-my',
        // permissions: ['jf_goods']
      },
      {
        title: '请购汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/purchase-requisition',
        permissions: ['jf_goods']
      },
      {
        title: '物料库',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/material-library'
      },
      {
        title: '成品库',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/product-library'
      },
      {
        title: '库存',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/inventory'
      }
    ]
  },
  shipmentManage: {
    title: '发货',
    icon: 'mdi-shipment',
    permissions: ['jf_shipment'],
    children: [
      {
        title: '项目汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/shipment-list',
        permissions: ['jf_shipment']
      },
      {
        title: '备货单汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/shipment-summary-list',
        permissions: ['jf_shipment']
      },
      {
        title: '发货单汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/delivery-order-list',
        permissions: ['jf_shipment']
      },
      {
        title: '箱子码',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/box-code',
        permissions: ['jf_shipment']
      }
    ]
  },
  customerServiceManage: {
    title: '客服',
    icon: 'mdi-headset',
    permissions: ['jf_service'],
    children: [
      {
        title: '项目汇总',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/customer-shipment-list'
      }
    ]
  },
  systemManage: {
    title: '管理',
    icon: 'mdi-cog',
    permissions: ['jf_admin'],
    children: [
      {
        title: '人员管理',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/staff',
        permissions: ['jf_admin']
      }
    ]
  },
  noticeManage: {
    title: '公告',
    icon: 'mdi-bell',
    permissions: ['jf_anno'],
    children: [
      {
        title: '公告',
        childTitle: '',
        childClass: '',
        icon: '',
        to: '/notice',
        permissions: ['jf_anno']
      }
    ]
  }
}

// 获取导航菜单
export function getNavMenus() {
  const userStore = useUserStore()
  const mainModules = ['panelManage', 'businessControl', 'estimateControl', 'materialControl', 'designControl', 'boughtManage', 'productionManage', 'auditFinanceControl', 'auditGroupControl', 'systemManage', 'factoryManufactureManage', 'noticeManage', 'storeManage', 'jf_bts', 'shipmentManage', 'customerServiceManage'] as const
  return mainModules.map(moduleName => {
    // console.log('mainModules:', mainModules)
    const config = menuConfig[moduleName]
    if (!config) return null

    // 检查权限
    if (config.permission && !userStore.hasPermission(config.permission)) {
      return null
    }
    if (config.permissions && !config.permissions.some((p: string) => userStore.hasPermission(p))) {
      return null
    }

    // console.log('mainModules:', mainModules)
    // console.log('config.children:', config.children)
    // 如果有子菜单，返回子菜单配置
    if (config.children) {
      const filteredChildren = config.children.filter((child: MenuItem) => {
        // 产品复核权限
        if (child.to === '/material-pending-control-manage') {
          if (userStore.userInfo?.nickname !== '王曙' && userStore.userInfo?.nickname !== '吴秋南' && userStore.userInfo?.nickname !== '崔秀娟' && userStore.userInfo?.nickname !== '王胜利' && userStore.userInfo?.nickname !== '系统人员' && !userStore.userInfo?.nickname.includes('江丰') && !userStore.userInfo?.nickname.includes('测试')) {
            return false
          }
        }

        // // 发货导航
        // if (child.to === '/shipment-list') {
        //   if (userStore.userInfo?.nickname !== '周小君' && userStore.userInfo?.nickname !== '系统人员' && !userStore.userInfo?.nickname.includes('江丰') && !userStore.userInfo?.nickname.includes('测试')) {
        //     return false
        //   }
        // }

        return !child.permissions || child.permissions.some((p: string) => userStore.hasPermission(p))
      })
      
      if (filteredChildren.length === 0) return null
      
      return {
        title: config.title,
        icon: config.icon,
        children: filteredChildren.map((child: MenuItem) => ({
          title: child.title,
          childTitle: child.childTitle,
          childClass: child.childClass,
          icon: child.icon,
          path: child.to
        }))
      }
    }

    // 否则返回主菜单配置
    return {
      title: config.title,
      icon: config.icon,
      path: `/${moduleName}`
    }
  }).filter(Boolean)
}

export default router
